export default __webpack_public_path__ + "static/media/wp.0abe9604.png";